/**
 * Baseline UI catalog (pt-BR).
 * Every key used by t() / data-i18n must exist here.
 * Overlay locales (pt-PT) only override differences.
 */
export const catalogPtBR = Object.freeze({
  // Tax ID
  "fields.taxId.cnpj": "CNPJ",
  "fields.taxId.nif": "NIF",
  "fields.taxId.es": "NIF/NIE",

  // Phone / WhatsApp
  "fields.phone": "Telefone",
  "fields.phoneCommercial": "Telefone comercial",
  "fields.phoneWhatsapp": "Telefone / WhatsApp",
  "fields.phoneWhatsappLine": "Telefone WhatsApp",
  "fields.phonePlaceholder.br": "(00) 0 0000-0000",
  "fields.phonePlaceholder.pt": "912 345 678",

  // Address / city
  "fields.address": "Endereço completo",
  "fields.address.placeholder.ufIbge": "Rua, número, bairro, cidade, estado e CEP",
  "fields.address.placeholder.freeform": "Rua, número, localidade e código postal",
  "fields.address.streetLine": "Endereço",
  "fields.address.streetLine.placeholder": "Rua e número",
  "fields.address.postalCode": "Código postal",
  "fields.address.postalCode.placeholder": "1000-001",
  "fields.address.city": "Cidade",
  "fields.address.city.placeholder": "Lisboa",
  "fields.address.region": "Região (opcional)",
  "fields.address.region.placeholder": "Distrito ou província",
  "fields.city": "Cidade",
  "fields.city.placeholder": "Digite a cidade...",
  "fields.city.select": "Selecione a cidade",

  // Config geo regions
  "config.geo.activeRegions.title.br": "Estados Ativos",
  "config.geo.activeRegions.title.pt": "Distritos ativos",
  "config.geo.activeRegions.title.es": "Províncias ativas",
  "config.geo.activeRegions.hint.br":
    "Selecione os estados cujas cidades estarão disponíveis no sistema.",
  "config.geo.activeRegions.hint.pt":
    "Selecione os distritos cujas localidades estarão disponíveis no sistema.",
  "config.geo.activeRegions.hint.es":
    "Selecione as províncias cujas cidades estarão disponíveis no sistema.",
  "config.geo.priorityCities.hint.catalog":
    "Selecione cidades-foco para aparecer primeiro nos dropdowns de cidade.",
  "config.geo.priorityCities.hint.freeform":
    "Escolha cidades-foco a partir da lista cadastrada (aparecem primeiro nas sugestões).",

  // Access / users
  "access.user": "Usuário",
  "access.users": "Usuários",
  "access.newUser": "Novo Usuário",
  "access.editUser": "Editar Usuário",
  "access.usersTitle": "Usuários do Sistema",
  "access.usersDescription":
    "Gerencie quem tem acesso ao Lead Control. Selecione um usuário na tabela para editar ou excluir.",
  "access.loadingUsers": "Carregando usuários...",
  "access.emailPlaceholder": "usuario@empresa.com.br",
  "access.emptyUsers": "Nenhum usuário cadastrado.",

  // Lead / funil critical actions
  "lead.copyPhone": "Copiar telefone",
  "lead.phoneEmpty": "Telefone vazio, nada para copiar.",
  "lead.phoneCopied": "Telefone copiado com sucesso!",
  "lead.phoneCopyFailed": "Falha ao copiar telefone.",
  "lead.phoneRequired": "Telefone é obrigatório",
  "lead.phoneInvalid.br":
    "Telefone inválido para o país da clínica. Use DDD + número, ex.: (11) 98765-4321.",
  "lead.phoneInvalid.pt":
    "Telemóvel inválido para o país da clínica. Use 9 dígitos (móvel 9… ou fixo 2…).",
  "lead.phoneInvalid.es":
    "Telefone inválido para o país da clínica. Use 9 dígitos (móvel 6/7… ou fixo 8/9…).",
  "lead.phoneInvalid.generic": "Telefone inválido para o país da clínica.",
  "lead.rows.one": "1 linha",
  "lead.rows.other": "{count} linhas",
  "lead.submit.one": "Inserir 1 lead",
  "lead.submit.other": "Inserir {count} leads",
  "lead.success.one": "Lead adicionado com sucesso!",
  "lead.success.other": "{count} leads adicionados com sucesso!",
  "lead.registering.one": "Registrando lead…",
  "lead.registering.other": "Registrando leads…",

  // Config validation (tax / phone commercial)
  "validation.taxId.invalid.cnpj":
    "CNPJ inválido. Informe 14 dígitos no formato 00.000.000/0000-00 e confirme se o número é válido.",
  "validation.taxId.invalid.nif": "NIF inválido. Confirme os 9 dígitos e o dígito de controlo.",
  "validation.taxId.invalid.es":
    "NIF/NIE inválido. Informe 9 caracteres (DNI, NIE ou NIF de entidade) com a letra ou dígito de controlo corretos.",
  "validation.phoneCommercial.invalid":
    "Telefone comercial inválido para o país da clínica. Exemplo: (11) 98765-4321.",
});
